import restService from "../rest-service/RestService";
import { IAlarmScheduleModel, defaultAlarmSchedule } from "./Models";

type AlarmScheduleQueryParams = {
    groupID?: number;
    includeLinkedAlarmSchemes?: boolean;
}

const AlarmScheduleAdministrationDataService = {

    getAlarmSchedules: async function (organizationID: number,
        groupID: number,
        includeLinkedAlarmSchemes: boolean,
        signal?: AbortSignal
        ) : Promise<IAlarmScheduleModel[]> {

        const path = `/organizations/${organizationID}/alarmSchedules`;


        const queryParams: AlarmScheduleQueryParams = {
            groupID: groupID,
            includeLinkedAlarmSchemes: includeLinkedAlarmSchemes
        };

        const response = await restService.get<IAlarmScheduleModel[], AlarmScheduleQueryParams>(path, signal, queryParams);
        return response.data;
    },
    getAlarmSchedule: async function(organizationID: number,
        groupID: number,
        alarmScheduleID: number,
        includeLinkedAlarmSchemes: boolean,
        signal?: AbortSignal
        ): Promise<IAlarmScheduleModel> {

        if (alarmScheduleID > 0) {

            const path = `/organizations/${organizationID}/alarmSchedules/${alarmScheduleID}`;

            const queryParams: AlarmScheduleQueryParams = {
                groupID: groupID,
                includeLinkedAlarmSchemes: includeLinkedAlarmSchemes
            };
    
            const response = await restService.get<IAlarmScheduleModel, AlarmScheduleQueryParams>(path, signal, queryParams);
            return response.data;
        } else {
            return defaultAlarmSchedule;
        }
    
    },
    saveAlarmSchedule: async function(organizationID: number,
        groupID: number,
        alarmSchedule: IAlarmScheduleModel): Promise<IAlarmScheduleModel> {

            const path = `/organizations/${organizationID}/alarmSchedules`;

            const queryParams: AlarmScheduleQueryParams = {
                groupID: groupID,
            };

            const response = await restService.post<IAlarmScheduleModel, IAlarmScheduleModel, AlarmScheduleQueryParams>(path, alarmSchedule, undefined, undefined, queryParams);
            return response.data;
    },
    deleteAlarmSchedule: async function(organizationID: number,
        groupID: number,
        alarmScheduleID: number
    ): Promise<void> {

        const path = `/organizations/${organizationID}/alarmSchedules/${alarmScheduleID}`;

        const queryParams: AlarmScheduleQueryParams = {
            groupID: groupID,
        };

        const response = await restService.delete<void, AlarmScheduleQueryParams>(path, undefined, queryParams);
        return response.data;
    }
};

export default AlarmScheduleAdministrationDataService;

